import { toast } from "react-toastify"
import {
    FunnelRevenueResult,
    OpportunitiesResult,
    OpportunityDashboardFilters,
    OpportunityDashboardSearchFields,
    OpportunityOutcomeType,
    OutcomeResult,
} from "models/opportunity-dashboard"
import { buildQueryString } from "utils/query-string"

// API calls only: no Redux dispatches here (see CLAUDE.md, thunk/Redux separation).

const BASE_URL = `${process.env.REACT_APP_API_URL}/opportunity/dashboard`

// Returns the response's `data`, or null after showing the error.
const getJson = async <T>(path: string, errorMessage: string): Promise<T | null> => {
    try {
        const res = await fetch(`${BASE_URL}${path}`, { method: "GET", credentials: "include" })
        const json = await res.json()
        if (!res.ok) throw new Error(json.message)
        return json.data as T
    } catch (err: any) {
        toast.error(err.message ?? errorMessage)
        return null
    }
}

const toQuery = (f: OpportunityDashboardFilters) => buildQueryString({
    fy: f.fiscalYear,
    divisionIds: f.divisionIds,
    departmentIds: f.departmentIds,
    branchIds: f.branchIds,
    months: f.months,
    search: f.search,
})

export const getOpportunityDashboardSearchFields = () =>
    getJson<OpportunityDashboardSearchFields>("/search-fields", "Error loading filter options")

export const getOpportunityFunnel = (filters: OpportunityDashboardFilters) =>
    getJson<FunnelRevenueResult>(`/funnel${toQuery(filters)}`, "Error loading funnel")

export const getOpportunityList = (filters: OpportunityDashboardFilters) =>
    getJson<OpportunitiesResult>(`/opportunities${toQuery(filters)}`, "Error loading opportunities")

export const getOpportunityOutcome = (type: OpportunityOutcomeType, filters: OpportunityDashboardFilters) =>
    getJson<OutcomeResult>(`/outcome/${type}${toQuery(filters)}`, "Error loading report")
